var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 4a8.5 8.5 0 110 17 8.5 8.5 0 010-17zm-.563 6.497c-.299 0-.617.046-.95.167-.653.239-.508.833-.363.833.294 0 .491.052.596.156.104.104.158.287.158.552 0 .146-.02.309-.052.486a9.675 9.675 0 01-.125.562l-.56 2.069a7.607 7.607 0 00-.108.584 3.942 3.942 0 00-.033.508c0 .424.15.775.45 1.051.3.278.761.535 1.302.535.351 0 .853-.137 1.26-.337.468-.229.716-.66.473-.857-.14-.113-.324.075-.459.075-.288 0-.491-.05-.608-.149-.118-.1-.175-.285-.175-.559 0-.11.017-.27.053-.481a6.03 6.03 0 01.122-.569l.557-2.06c.053-.19.092-.397.112-.623.02-.229.03-.386.03-.476 0-.433-.146-.787-.437-1.059-.29-.27-.705-.408-1.243-.408zM13.172 7c-.364 0-.68.128-.94.383-.26.255-.392.561-.392.92 0 .36.131.666.391.919.262.252.577.379.941.379.366 0 .678-.127.938-.38.26-.252.39-.558.39-.918 0-.359-.13-.665-.39-.92A1.291 1.291 0 0013.172 7z",
    fill: "#0B0B0B",
    fillRule: "evenodd"
  })));
}

export default SvgInfo;